export default __webpack_public_path__ + "6c4eebd68149cc65ab49e41118db5816.png";